module.exports = __webpack_public_path__ + "img/tool box.66cee68b.png";